import { render } from "./CerimoniaCivile.vue?vue&type=template&id=24996499&scoped=true"
import script from "./CerimoniaCivile.vue?vue&type=script&lang=js"
export * from "./CerimoniaCivile.vue?vue&type=script&lang=js"

import "./CerimoniaCivile.vue?vue&type=style&index=0&id=24996499&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-24996499"

export default script